import React from "react";
import { HashLink } from "react-router-hash-link";
import coinImg from "../../../assets/img/treydora_redesign/brand/treydorex coin.webp";
import { SITE_NAV_ROUTES } from "../../../constants/siteNavRoutes";
import { trackHomepageCtaClick } from "../../../utils/analytics";

const HomeRpgEcosystemBanner = () => {
  return (
    <section className="td-rpg-eco" aria-labelledby="td-eco-heading">
      <div className="td-rpg-inner td-rpg-eco__inner">
        <div className="td-rpg-eco__coin">
          <img src={coinImg} alt="Treydorex" loading="lazy" decoding="async" />
        </div>
        <div className="td-rpg-eco__text">
          <h2 id="td-eco-heading">TREYDOREX IS THE KEY TO THE ECOSYSTEM</h2>
          <p>
            The lifeblood of the Treydora universe. Power your journey. Own your
            legacy—access, upgrades, and on-chain participation begin here.
          </p>
          <HashLink
            smooth
            to={SITE_NAV_ROUTES.TOKEN_SALE}
            className="td-btn-gold"
            onClick={() =>
              trackHomepageCtaClick({
                cta_id: "ecosystem_buy_treydorex",
                section: "ecosystem_banner",
                destination: SITE_NAV_ROUTES.TOKEN_SALE,
              })
            }
          >
            BUY TREYDOREX NOW
          </HashLink>
        </div>
      </div>
    </section>
  );
};

export default HomeRpgEcosystemBanner;
